export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            关于我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-6">
            关于17吃瓜
          </h2>
          <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
            <strong>17吃瓜网</strong>创立于2020年，是国内领先的<strong>吃瓜在线</strong>内容聚合平台。我们以「快、准、全」为核心运营理念，每日追踪娱乐圈、网红圈、直播圈、体育圈等热门领域的<strong>最新黑料</strong>与独家资源。作为<strong>吃瓜网站</strong>行业的标杆，<strong>17一起吃瓜网</strong>不仅提供网页端<strong>吃瓜首页</strong>入口，更开发了专属<strong>吃瓜APP</strong>，让瓜友随时随地掌握第一手资讯。平台内容覆盖明星八卦、网红翻车、综艺内幕、社会热点等方向，所有<strong>吃瓜资源</strong>均经过多源交叉验证，确保信息的真实性与时效性。目前每日活跃用户超过百万，已成为广大网友<strong>每日黑料</strong>获取的首选<strong>吃瓜平台</strong>。
          </p>
        </div>
      </div>
    </section>
  );
}